var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 11.77,
    viewBox: "0 0 17.24 11.77",
    width: 17.24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1389.21-1599.04-4.21-3.62v2.48h-5.54v2.27h5.54v2.48zm-13.02 3.4v-2.48l-4.22 3.62 4.22 3.61v-2.47h5.54v-2.28z",
    fill: "#fff",
    transform: "translate(-1371.97 1602.66)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.40fb8e49ba1ef3570be34e3389740f21.svg";
export { ForwardRef as ReactComponent };